

import React, { memo, useCallback, useContext } from 'react';
import GoogleLogin from 'react-google-login';
import { SOCIAL_TYPE } from '@shootsta/common-domain-data';
import globalConfig from 'react-global-configuration';
import SocialAuthButton from './SocialAuthButton';
import { SocialAuthButtonListContext } from '../context/SocialAuthButtonListContext';
import { getSocialAuthGoogleIdToken } from '../utils/socialAuthGoogle';



const type = SOCIAL_TYPE.GOOGLE;

const SocialAuthButtonGoogle = () => {
  const clientId = globalConfig.get('socialGoogleClientId');

  const { onAuthSuccess, onAuthError } = useContext(SocialAuthButtonListContext);

  const onSuccess = useCallback(async (data) => {
    onAuthSuccess({ type, token: getSocialAuthGoogleIdToken(data) });
  }, [onAuthSuccess]);

  const onFailure = useCallback(() => {
    onAuthError();
  }, [onAuthError]);

  const onRender = useCallback(({ onClick }) =>
  <SocialAuthButton
    type={type}
    onClick={onClick} />,


  []);

  return (
    <GoogleLogin
      clientId={clientId}
      cookiePolicy="single_host_origin"
      render={onRender}
      onSuccess={onSuccess}
      onFailure={onFailure} />);


};

export default memo(SocialAuthButtonGoogle);